import styled from 'styled-components';
import { Avatar, Paper } from '@mui/material';


const ChatWindowAvatar = styled(Avatar)`
    margin-right: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const MessageContainer = styled.div`
    margin-bottom: 16px;
    display: flex;
    width: ${props => props.width || '70%'};
    align-items: flex-start;
    flex-direction: ${props => props.itemType === 'sent' ? 'row-reverse' : 'row'};
`;

const MessageWrapper = styled.div`
    padding: 12px 16px;
    border-radius: 18px;
    max-width: 85%;
    position: relative;
    transition: all 0.2s ease;
    margin: ${props => props.itemType === 'sent' ? '0 8px 0 12px' : '0 12px 0 0'};
    
    ${props => props.itemType === 'sent' ? `
        background: linear-gradient(135deg, #2F80ED, #2F80ED);
        color: white;
        border-bottom-right-radius: 4px;
        box-shadow: 0 2px 4px rgba(47, 128, 237, 0.6);
        line-height: 0.5;
        
        &:hover {
            box-shadow: 0 4px 8px rgba(47, 128, 237, 0.2);
        }
    ` : `
        background: white;
        color: #333333;
        border-bottom-left-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
        
        &:hover {
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }
    `}

    > * {
        margin: 0;
        font-size: 0.95rem;
        font-family: 'Inter', sans-serif;
        line-height: ${props => props.itemType === 'sent' ? 'normal' : '1.5'};
    }

    .markdown-content, .html-content {
        width: 100%;
        overflow-x: auto;
    }
`;

const MessageButtonsWrapper = styled.div`
    display: flex;
    gap: 10px;
    margin-top: ${props => props.mt ||'20px'};
    align-items: center;

    a {
        cursor: pointer;
    }
`;

const EditMessageWrapper = styled.div`
    padding: 12px;
    border-radius: 12px;
    width: 100%;
    color: ${props => props.theme.colors.black};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    > * {
        margin: 0;
    }
`;

const EditMessageText = styled.div`
    ${props => props.theme.fonts.variant.light};
    font-size: ${props => props.theme.fonts.size.medium};
    color: ${props => props.theme.colors.black};
    text-align: center;
`;

const EditMessageInput = styled.textarea`
    resize: none;
    padding: 5px 10px;
    border-radius: 10px;

    &:focus {
        outline: none;
    }
`
const EditMessageInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    color: ${props => props.theme.colors.black};
`;

const ChatBoxContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;

const ChatMessagesWrapper = styled.div`
    overflow-y: auto;
    flex: 2;
    max-height: 924px;
    min-height: 300px;
    border-radius: 8px;
    
    /* Estilos para el scrollbar */
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
    
    /* Playground-specific: Override inner ChatWindowComponentPaper styles */
    > div {
        overflow-y: visible !important;
        align-items: stretch !important;
    }
    
    /* Playground-specific: Align sent messages to the right */
    [data-message-type="sent"] {
        margin-left: auto !important;
    }
`;

const ChatInputWrapper = styled.div`
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const MessageInfo = styled.p`
    margin: 0;
    color: ${props => props.theme.colors.davysGrey};
    font-size: ${props => props.itemType === 'sent' ? '0.8em' : '0.8em'};
`
export {
  ChatWindowAvatar,
  MessageContainer,
  MessageWrapper,
  MessageButtonsWrapper,
  EditMessageWrapper,
  EditMessageText,
  EditMessageInput,
  EditMessageInputWrapper,
  ChatBoxContainer,
  ChatMessagesWrapper,
  ChatInputWrapper,
  MessageInfo
}
